const BAR_ID = 'managerTopLoadingBar';
const COMPLETE_HOLD_MS = 300;

let hideTimer = null;

function ensureBar() {
    let bar = document.getElementById(BAR_ID);
    if (!bar) {
        bar = document.createElement('div');
        bar.id = BAR_ID;
        bar.className = 'top-loading-bar';
        const fill = document.createElement('div');
        fill.className = 'top-loading-bar__fill';
        bar.appendChild(fill);
        document.body.appendChild(bar);
    }
    return bar;
}

export function showTopLoadingBar() {
    const bar = ensureBar();
    window.clearTimeout(hideTimer);
    bar.classList.remove('top-loading-bar--complete', 'top-loading-bar--active');
    void bar.offsetWidth;
    bar.classList.add('top-loading-bar--active');
}

export function hideTopLoadingBar() {
    const bar = ensureBar();
    if (!bar.classList.contains('top-loading-bar--active')) {
        return;
    }
    bar.classList.add('top-loading-bar--complete');
    hideTimer = window.setTimeout(() => {
        bar.classList.remove('top-loading-bar--active');
        window.setTimeout(() => {
            bar.classList.remove('top-loading-bar--complete');
        }, 300);
    }, COMPLETE_HOLD_MS);
}
